import { WithStyles, withStyles } from '@mui/styles';
import { FirmRecord } from '@tassat/fred-definitions';

import { FirmAccounts } from './firmAccounts';
import { muiStyles } from './firmAccountsStyles';

export interface IFirmWalletsProps extends WithStyles<typeof muiStyles> {
    firm: FirmRecord;
}

export default withStyles(muiStyles)(FirmAccounts);